import BaseModelAPI from '../BaseModelAPI';

export default class SuratJalanDeliverySubconDetail extends BaseModelAPI {
	static entity = 'suratjalandeliverysubcondetail';
	static entityName = 'suratjalandeliverysubcondetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.suratJalanDeliverySubconId = '';
			this.suratJalanDeliverySubcon = {};
			this.partId = '';
			this.part = {};
			this.partName = '';
			this.orderQty = 0;
			this.deliveryQty = 0;
			this.stockVendorQty = 0;
			this.deliveryInstructionSubconDetailId = '';
			this.deliveryInstructionSubconDetail = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}